module.exports = __webpack_public_path__ + "static/img/test1.5e5ee4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/test/test1.jpg
// module id = 3afY
// module chunks = 2